/**
 * BetaAccessGate — porteiro do beta privado no client.
 *
 * Roda DEPOIS do ProtectedRoute (precisa de sessão pra existir e-mail) e ANTES
 * do OnboardingGuard (quem está fora da lista não deve nem onboardar).
 *
 * Este componente só ROTEIA. O veredito, o cache por uid e a política de
 * fail-open vivem em `betaVerdict.ts` — foram pra lá no BUG-93, quando a `/`
 * passou a precisar da mesma resposta pra não jogar quem está na fila de volta
 * na tela de beta fechado (ver cabeçalho de lá).
 *
 * Não dá pra "burlar pelo client" no sentido que importa: a lista não é
 * legível daqui e o e-mail não é auto-declarado.
 */

import { lazy, Suspense, type ReactElement } from "react";
import { useBetaVerdict } from "./betaVerdict";
import { SessionBootScreen } from "../components/boot/SessionBootScreen";

// Tela do caminho INFELIZ (beta fechado, que está aberto desde 01/09): era
// import estático e levava o formulário de fila inteiro para o entry de todo
// boot. Lazy — quem cair nela paga o chunk, ninguém mais (17/09).
const BetaClosed = lazy(() => import("../pages/BetaClosed"));

export function BetaAccessGate({ children }: { children: ReactElement }) {
  const verdict = useBetaVerdict();

  // O veredito agora tem teto de 10s e cai em fail-open quando estoura, então
  // este estado é curto por construção. A tela de marca substituiu o disco
  // girando pelo mesmo motivo do `RootEntry`: era um spinner sem nada a dizer.
  if (verdict === "pending") {
    return <SessionBootScreen message="Verificando seu acesso…" />;
  }
  if (verdict === "blocked") {
    return (
      <Suspense fallback={<SessionBootScreen message="Verificando seu acesso…" />}>
        <BetaClosed />
      </Suspense>
    );
  }
  return children;
}
